module.exports = __webpack_public_path__ + "static/media/core1.c1fd2231.png";